import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'

export const getCookie = async (key: string) => {
  let result: boolean | string | null | undefined = undefined

  if (Capacitor.isNativePlatform()) {
    const { value } = await Preferences.get({ key })
    result = value
  } else {
    result = useCookie(key).value ?? undefined
  }

  return result === 'true' ? true : (result === 'false' ? false : result ?? undefined)
}

export const setCookie = async (
  key: string,
  value: string | boolean | number,
  options?: {
    maxAge?: number
    isGlobal?: boolean
  }
) => {
  if (Capacitor.isNativePlatform()) {
    await Preferences.set({
      key, value: value.toString()
    })
  } else {
    const cookie = useCookie(key, {
      maxAge: options?.maxAge ?? 99999999,
      domain: options?.isGlobal ? useRuntimeConfig().public.COOKIE_DOMAIN : undefined,
    })

    cookie.value = value.toString()
  }

  return value
}

export const deleteCookie = async (
  key: string,
  options?: {
    isGlobal?: boolean
  }
) => {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key })
  } else {
    const cookie = useCookie(key, {
      domain: options?.isGlobal ? useRuntimeConfig().public.COOKIE_DOMAIN : undefined
    })
    cookie.value = null
  }
  
  return true
}